import { ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { catchErrorLogRet } from '../../../common/rest.operators';
import { PayloadAction } from '../../../store.model';
import { EvaluationService } from '../../core';
import { getModuleInjector } from '../../evaluation.metadata';
import { ActionType } from '../landing.action';

import {
    ChangeDateRange,
    changeDateRangeResult,
} from './change-date-range.action';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const changeDateRange = (
    action: Observable<PayloadAction<ActionType, ChangeDateRange>>,
) =>
    action.pipe(
        ofType(ActionType.EVAL_LANDING__CHANGE_DATE_RANGE),
        mergeMap((act: PayloadAction<ActionType, ChangeDateRange>) => {
            const service =
                getModuleInjector().get<EvaluationService>(EvaluationService);

            return service.search(act.payload.params).pipe(
                map((ret) => {
                    return changeDateRangeResult(
                        {
                            ...act.payload,
                            result: ret,
                        },
                        act.storePath,
                    );
                }),
                catchErrorLogRet(
                    of(
                        changeDateRangeResult(
                            { ...act.payload },
                            act.storePath,
                        ),
                    ),
                ),
            );
        }),
    );
